import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import AdminAffiliates from '@/components/admin/affiliates'
import AdminOrders from '@/components/admin/orders'
import AdminReports from '@/components/admin/reports'
import AdminSettings from '@/components/admin/settings'
import AdminSystemSettings from '@/components/admin/settings/system'
import AdminUsers from '@/components/admin/users'
import AdminUser from '@/components/admin/users/show'

import Account from '@/components/account'

import proxyCreate from '@/components/proxy/create'
import proxyCheckout from '@/components/proxy/checkout'

import CreateItem from '@/components/create'
import Checkout from '@/components/checkout'

import Items from '@/components/items'

import Orders from '@/components/orders'
import Order from '@/components/orders/show'
import Reorder from '@/components/orders/reorder'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/admin/affiliates', component: AdminAffiliates },
    { path: '/admin/orders', component: AdminOrders },
    { path: '/admin/reports', component: AdminReports },
    { path: '/admin/settings', component: AdminSettings },
    { path: '/admin/system', component: AdminSystemSettings },
    { path: '/admin/users', component: AdminUsers },
    { path: '/admin/users/:id', component: AdminUser },

    { path: '/account', component: Account },

    { path: '/proxy/create', component: proxyCreate },
    { path: '/proxy/checkout', component: proxyCheckout },

    { path: '/checkout', component: Checkout },
    { path: '/create', component: CreateItem },
    { path: '/create/:product_name', component: CreateItem },

    { path: '/items', component: Items },
    { path: '/items/:id', component: CreateItem },
    { path: '/orders', component: Orders },
    { path: '/orders/:id', component: Order },
    { path: '/reorder/:id', component: Reorder },
    { path: '*', redirect: '/items' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js